// @ts-nocheck
import { AccordionSectionPanel, AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { focusStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

/* Store Custom Code - Start */
import Minus, { MinusOffset } from "@store/Library/Components/Toolkit/Icons/Minus";
import Plus, { PlusOffset } from "@store/Library/Components/Toolkit/Icons/Plus";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
/* Store Custom Code - End */

const borderWidth = pxToRem(1);
const borderCss = css`
    ${({ theme }) => `${borderWidth} solid ${resolveColor("common.border", theme)}`}
`;

const _headerButtonBaseStyles = () => {
    return css`
        ${focusStyles()}
        padding: ${pxToRem(16, 0)};
        background-color: transparent;
        border: none;
        border-top: ${borderCss};
        border-bottom: ${borderCss};
        color: inherit;
        transition: ${transitionHoverStyles("color")};

        ${({ theme }) => css`
            font-size: ${theme.design.typography.size.smallest}; /* Store Custom Code */
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.small};
        `}

        &[aria-expanded="true"] {
            border-bottom-color: transparent;
        }

        &:hover {
            color: ${getColor("primary.main")};
        }
    `;
};

const _headerButtonStyles = () => {
    return css`
        button {
            ${_headerButtonBaseStyles()}

            &:focus,
            &:focus-visible {
                ${_headerButtonBaseStyles()}
            }
        }
    `;
};

export const accordionFooterSectionProps: AccordionSectionPresentationProps = {
    headerProps: {
        css: css`
            ${_headerButtonStyles()}
            background-color: transparent;

            ${AccordionSectionPanel} + && {
                ${_headerButtonStyles()}
                margin-top: -${borderWidth};
            }
        `,
    },
    panelProps: {
        css: css`
            padding: ${pxToRem(0, 0, 16)};
            border: none;
            border-bottom: ${borderCss};
        `,
    },
    /* Store Custom Code - Start */
    expandIconProps: {
        src: Plus,
        color: "primary",
        css: css`
            ${iconScalableStyles("1.2em", PlusOffset)}
            margin-left: 1em;
        `,
    },
    collapseIconProps: {
        src: Minus,
        color: "primary",
        css: css`
            ${iconScalableStyles("1.2em", MinusOffset)}
            margin-left: 1em;
        `,
    },
    /* Store Custom Code - End */
};
